import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import ScrollComponent from '../../common/ScrollComponent';
import { compose } from 'redux';
import { withComponentId } from '../../common/ComponentIdContext';
import Loading from '../../common/loading/Loading';
import { formatPrice } from '../../helpers/Text';
import { fetchStatChartData, REDUCER_NAME } from './reducer';
import HorizontalBarChart from './HorizontalBarChart';

const mapTimeRange = {
  2: 'OneWeek',
  3: 'OneMonth',
  4: 'ThreeMonths',
};

class StatChart extends PureComponent {
  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { currentTab, condition } = this.props;
    if (
      currentTab !== prevProps.currentTab ||
      condition.code !== prevProps.condition.code
    ) {
      this.fetchData();
    }
  }

  fetchData = () => {
    const {
      fetchStatChartData,
      currentTab,
      componentId,
      condition,
    } = this.props;
    const timeRange = mapTimeRange[currentTab];
    fetchStatChartData(
      {
        TimeRange: timeRange,
        Code: condition.code,
      },
      componentId,
    );
  };

  priceFormatter = () => {
    const { condition } = this.props;
    const formatDerivative = val => val;

    return condition.isDerivatives ? formatDerivative : formatPrice;
  };

  getData = () => {
    const { currentTab, statData } = this.props;
    const timeRange = mapTimeRange[currentTab];
    if (!statData[timeRange]) {
      return [];
    }
    const data = [];
    statData[timeRange]
      .concat()
      .sort((a, b) => a.price - b.price)
      .forEach(item => {
        if (!item.volume) {
          return;
        }
        data.push({
          ...item,
          price: this.priceFormatter()(item.price),
        });
      });

    return data;
  };

  getWidth = () => {
    const { width } = this.props;

    return width - 20;
  };

  getHeight = () => {
    const data = this.getData();

    return Math.max(data.length * 10, 310);
  };

  render() {
    const { topContent, theme, isFetching, condition, height } = this.props;
    const width = this.getWidth();
    const data = this.getData();
    if (!data || data.length < 2) {
      return <div>{I18n.t('common.NO_DATA')}</div>;
    }

    return (
      <div className="stat-chart">
        <ScrollComponent appendStyle={{ maxHeight: height }}>
          <div className="title">{I18n.t('timeAndSale.chartTitle')}</div>
          {isFetching && <Loading />}
          <HorizontalBarChart
            theme={theme}
            isDerivatives={condition.isDerivatives}
            key={width}
            chartWidth={width - 5}
            refPrice={
              condition.isDerivatives
                ? topContent.ReferencePrice
                : topContent.ReferencePrice / 1000
            }
            data={data}
          />
        </ScrollComponent>
      </div>
    );
  }
}

const mapStateToProps = (state, { componentId }) => ({
  statData: state[REDUCER_NAME].listMultiComponent[componentId].statData,
  condition: state[REDUCER_NAME].listMultiComponent[componentId].condition,
  topContent: state[REDUCER_NAME].listMultiComponent[componentId].topContent,
  isFetching: state[REDUCER_NAME].listMultiComponent[componentId].isFetching,
  theme: state.theme,
  locale: state.i18n.locale,
});

const mapDispatchToProps = {
  fetchStatChartData,
};

export default compose(
  withComponentId,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(StatChart);
